
export default class Cargo {
  public id: string;
  public containerId: string;
  public devices: Array<string>;

  constructor(data: any) {
    this.parse(data);
  }

  private parse(data: any): void {
    this.id = data["SendumId"];
    this.containerId = data["ContainerId"];

    this.devices = data["devices"] || [];

  }
}
